import { Suspense } from 'react';

import PlayEditorInterfaceDirect, {
    PlayEditorProps,
} from '../../play-editor/play-editor-interface/play-editor-interface.js';
import { InlineLoadingSpinner } from '../../shared/interface/index.js';
import { DnDContext, lazyWrapper } from '../../shared/structural/index.js';
import PlayEditorWrapper from '../playEditorWrapper.js';
import { FieldContainerProvider, InteractionLayerProvider, PlayEditorMenuProvider } from '../providers/index.js';

const PlayEditorInterfaceLazy = lazyWrapper(
    () =>
        import(
            /* webpackChunkName: "play-editor-interface" */ '../../play-editor/play-editor-interface/play-editor-interface.js'
        )
);

const PlayEditorInterface = SSR ? PlayEditorInterfaceDirect : PlayEditorInterfaceLazy;

const PlayEditor: FC<PlayEditorProps & { readOnly?: boolean }> = ({ readOnly, ...props }) => {
    return (
        <Suspense fallback={<InlineLoadingSpinner />}>
            <PlayEditorWrapper readOnly={readOnly}>
                <DnDContext>
                    <FieldContainerProvider>
                        <InteractionLayerProvider>
                            <PlayEditorMenuProvider>
                                <PlayEditorInterface {...props} />
                            </PlayEditorMenuProvider>
                        </InteractionLayerProvider>
                    </FieldContainerProvider>
                </DnDContext>
            </PlayEditorWrapper>
        </Suspense>
    );
};

export default PlayEditor;
